// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarHeader__sidebarHeader___xveYW {
    display: flex;
    justify-content: space-between;
    margin: var(--space-s) 0;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/ProjectsView/ProjectSidebar/SidebarHeader/SidebarHeader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;AAC5B","sourcesContent":[".sidebarHeader {\n    display: flex;\n    justify-content: space-between;\n    margin: var(--space-s) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarHeader": `SidebarHeader__sidebarHeader___xveYW`
};
export default ___CSS_LOADER_EXPORT___;
